import React from "react";
import Popup from "reactjs-popup";

import "./pop-up.css";

// take two usestate input so as to control from the button of parent component
export const Modal = ({ showModal, setShowModal }) => {
  return (
    <Popup open={showModal} closeOnDocumentClick onClose={setShowModal}>
      <div className="modal">
        <button className="close" onClick={setShowModal}>
          &times;
        </button>
        <div className="header"> We are working on it ! </div>
        <div className="content">
          The feature you want to access is being developed. We are working on
          it and it will soon be available. Sorry for the inconvenience! You can
          contact us via email at thecountryyard.70@gmail.com for any further
          enquiry.
        </div>
        <div className="actions">
          <button
            className="button"
            onClick={() => {
              console.log("modal closed ");
              setShowModal();
            }}
          >
            Close
          </button>
        </div>
      </div>
    </Popup>
  );
};
